enum HumanProxyType {
  persona = 1,
  orgMember = 2,
}

export default HumanProxyType
